/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SendCustomTestEmailRequest
 */
export interface SendCustomTestEmailRequest {
    /**
     * Which email template to use for the test send (e.g. `1` or `2`).
     */
    template: string;
}

/**
 * Check if a given object implements the SendCustomTestEmailRequest interface.
 */
export function instanceOfSendCustomTestEmailRequest(value: object): value is SendCustomTestEmailRequest {
    if (!('template' in value) || value['template'] === undefined) return false;
    return true;
}

export function SendCustomTestEmailRequestFromJSON(json: any): SendCustomTestEmailRequest {
    return SendCustomTestEmailRequestFromJSONTyped(json, false);
}

export function SendCustomTestEmailRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SendCustomTestEmailRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'template': json['template'],
    };
}

export function SendCustomTestEmailRequestToJSON(json: any): SendCustomTestEmailRequest {
    return SendCustomTestEmailRequestToJSONTyped(json, false);
}

export function SendCustomTestEmailRequestToJSONTyped(value?: SendCustomTestEmailRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'template': value['template'],
    };
}

